module.exports = __webpack_public_path__ + "static/Mydusa-c1b4accc7fc1e20b28dda0c6e2990da4.jpg";